import { render } from "./OrderDetail.vue?vue&type=template&id=3d373d10&scoped=true"
import script from "./OrderDetail.js?vue&type=script&lang=js&external"
export * from "./OrderDetail.js?vue&type=script&lang=js&external"

import "./OrderDetail.scss?vue&type=style&index=0&id=3d373d10&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d373d10"]])

export default __exports__